{
  "slug": "does-sleep-affect-iq",
  "title": "Does Sleep Affect IQ Test Performance?",
  "description": "Poor sleep can affect attention, memory, speed, and consistency.",
  "category": "IQ questions answered",
  "sections": [
    {
      "heading": "Short answer",
      "paragraphs": ["Poor sleep can affect attention, memory, speed, and consistency."]
    },
    {
      "heading": "What affects it",
      "paragraphs": [
        "Test quality, age, health, language, education, motivation, environment, and purpose all matter.",
        "An average study effect cannot predict one person exactly."
      ]
    },
    {
      "heading": "Guidance",
      "paragraphs": [
        "Use adequate sleep, quiet conditions, accommodations, and a suitable instrument.",
        "For children, health, disability, or high-stakes decisions, consult a qualified professional."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "can-iq-change-over-time"],
  "sources": [],
  "faqs": [],
  "summary": "Poor sleep can affect attention, memory, speed, and consistency. Content reviewed 18 July 2026."
}
